import { useEffect, useRef, useState } from 'react';

const useIsBelowViewport = () => {
  const containerRef = useRef(null);
  const [isBelowViewport, setIsBelowViewport] = useState(true);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!containerRef.current) return;

    const updateHeight = () => {
      if (containerRef.current) {
        setHeight(containerRef.current.getBoundingClientRect().height);
      }
    };

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(containerRef.current);
    window.addEventListener('resize', updateHeight);

    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        setIsBelowViewport(
          entry.boundingClientRect.bottom > window.innerHeight,
        );
      },
      { threshold: 1 },
    );
    intersectionObserver.observe(containerRef.current);

    updateHeight();

    return () => {
      resizeObserver.disconnect();
      intersectionObserver.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return { containerRef, isBelowViewport, height };
};

export { useIsBelowViewport };
